import { createApp } from 'vue'
import router from './router'
import App from './App.vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"
// VueAxios, axios,
import DefaultLayout from './layouts/DefaultLayout.vue'
import HomeLayout from './layouts/HomeLayout.vue'

const app = createApp(App).use(router)

app.component('default-layout', DefaultLayout)
app.component('home-layout', HomeLayout)
app.mount('#app')